import moment from 'moment'
import love_image from '../images/love.png'


export const CommentCard = (props) =>
{
    return (
        <div className="w-100 mb-2">
            <div className="row align-items-center justify-content-center my-0 py-0">
                <div className="col-md-8">
                    <p className="smallrem m-0">
                        <span className='font-weight-bolder text-warning text-capitalize'>{props.comment_user}:</span>
                    </p>
                </div>
                <div className="col-md-4">
                    <p style={{fontSize: "10px"}}>{moment(props.timestamp).fromNow()}</p>
                </div>
            </div>
            <div className="row align-items-center justify-content-center ">
                <div className="col-md-8">

                    <p>{props.content}</p>
                </div>
                <div className="col-md-4">
                    <div className='row align-items-center justify-content-center'>
                        <button  className='btn btn-default'>
                            <img src={love_image} alt="" width={'15px'}
                                className='mx-1 animate__animated animate__tada animate__slow animate__infinite' />
                        </button>
                        <span className='font-weight-bold'>{props.likes} </span> &nbsp; likes

                    </div>  

                </div>
            </div>

        </div>
    )
}